import * as Yup from "yup";

// WORDPR4SS
const wordpressIntegrationValidationSchema = Yup.object({
  url: Yup.string().url("Invalid URL format").required("URL is required"),
  username: Yup.string().required("Username is required"),
  password: Yup.string().required("Password is required"),
});
const wordpressIntegrationInitialValues = {
  url: "",
  username: "",
  password: "",
};

const wordpressSettingsValidationSchema = Yup.object({
  publish_status: Yup.string().required("Publish status is required"),
  meta_title_field_name: Yup.string(),
  meta_description_field_name: Yup.string(),
});
const wordpressSettingsInitialValues = {
  publish_status: "",
  meta_title_field_name: "",
  meta_description_field_name: "",
};

// SHOPIFY
const shopifyIntegrationValidationSchema = Yup.object({
  url: Yup.string().url("Invalid URL format").required("URL is required"),
  version: Yup.string().required("Version is required"),
  access_token: Yup.string().required("Access token is required"),
});
const shopifyIntegrationInitialValues = {
  url: "",
  version: "",
  access_token: "",
};

const shopifySettingsValidationSchema = Yup.object({
  publish_status: Yup.string().required("Publish status is required"),
  blog_id: Yup.number()
    .typeError("Please select a valid blog")
    .nullable()
    .required("Blog ID is required"),
});
const shopifySettingsInitialValues = {
  publish_status: "",
  blog_id: "",
};

// WIX
const wixIntegrationValidationSchema = Yup.object({
  api_key: Yup.string().required("API Key is required"),
  account_id: Yup.string().required("Account ID is required"),
  site_id: Yup.string().required("Site ID is required"),
});
const wixIntegrationInitialValues = {
  api_key: "",
  account_id: "",
  site_id: "",
};

const wixSettingsValidationSchema = Yup.object({
  publish_status: Yup.string().required("Publish status is required"),
  member_id: Yup.string()
    .typeError("Please select a valid member")
    .nullable()
    .required("Member is required"),
});
const wixSettingsInitialValues = {
  publish_status: "",
  member_id: "",
};

// ALL
export const platforms = [
  {
    name: "WordPress",
    logo: "/wordpress-logo.png",
    url: "/wordpress",
    title: "Connecter votre site WordPress",
    btnText: "Connecter le site",
    updateBtnText: "Modifier l'intégration du site",
    tuto: {
      link: "/docs?menu=projets&submenu=wordpress",
      text: "Comment lier son site WordPress à BotBlogR ?",
    },
    integrationInitialValues: wordpressIntegrationInitialValues,
    settingsInitialValues: wordpressSettingsInitialValues,
    integrationValidationSchema: wordpressIntegrationValidationSchema,
    settingsValidationSchema: wordpressSettingsValidationSchema,
  },
  {
    name: "Shopify",
    logo: "/shopify-logo.png",
    url: "/shopify",
    title: "Connecter votre boutique Shopify",
    btnText: "Connecter la boutique",
    updateBtnText: "Modifier l'intégration de la boutique",
    tuto: {
      link: "/docs?menu=projets&submenu=shopify",
      text: "Comment lier sa boutique Shopify à BotBlogR ?",
    },
    integrationInitialValues: shopifyIntegrationInitialValues,
    settingsInitialValues: shopifySettingsInitialValues,
    integrationValidationSchema: shopifyIntegrationValidationSchema,
    settingsValidationSchema: shopifySettingsValidationSchema,
  },
  {
    name: "Wix",
    logo: "/wix-logo.png",
    url: "/wix",
    title: "Connecter votre site Wix",
    btnText: "Connecter le site",
    updateBtnText: "Modifier l'intégration du site",
    tuto: {
      link: "/docs?menu=projets&submenu=wix",
      text: "Comment lier son site Wix à BotBlogR ?",
    },
    integrationInitialValues: wixIntegrationInitialValues,
    settingsInitialValues: wixSettingsInitialValues,
    integrationValidationSchema: wixIntegrationValidationSchema,
    settingsValidationSchema: wixSettingsValidationSchema,
  },
];
